import type { PageContainerProps } from "@ant-design/pro-components";
import { PageContainer } from "@ant-design/pro-components";
import type { CSSProperties } from "react";

const dashboardPath = "/dashboard";

export const ADMIN_SURFACE_BORDER_STYLE: CSSProperties = {
  border: "1px solid var(--ant-colorBorderSecondary, #f0f0f0)",
};

export const ADMIN_MUTED_SURFACE_STYLE: CSSProperties = {
  border: "1px solid var(--ant-colorBorderSecondary, #e5e7eb)",
  background: "var(--ant-colorFillAlter, #fafafa)",
};

export const ADMIN_TERTIARY_TEXT_STYLE: CSSProperties = {
  color: "var(--ant-colorTextTertiary, #64748b)",
};

export type SharedAdminPageContainerProps = PageContainerProps & {
  showBack?: boolean;
};

export function AdminPageContainer({
  onBack,
  showBack,
  ...props
}: SharedAdminPageContainerProps) {
  const shouldShowBack = showBack ?? Boolean(onBack);
  const handleBack =
    onBack ??
    (() => {
      if (typeof window !== "undefined" && window.history.length > 1) {
        window.history.back();
        return;
      }
      if (typeof window !== "undefined") {
        window.location.assign(dashboardPath);
      }
    });

  if (shouldShowBack) {
    return <PageContainer {...props} onBack={handleBack} />;
  }
  return <PageContainer {...props} />;
}
